var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContetns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contetns",
    clipPath: "url(#clip0_8876_391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.1849 0.370371H4.81456C2.35996 0.370371 0.370117 2.36022 0.370117 4.81482V55.1852C0.370117 57.6398 2.35996 59.6296 4.81456 59.6296H55.1849C57.6395 59.6296 59.6294 57.6398 59.6294 55.1852V4.81482C59.6294 2.36022 57.6395 0.370371 55.1849 0.370371Z",
    stroke: "#1E1F22",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.7037 12.6C41.6963 12.3259 41.6815 12.0519 41.6593 11.7778C41.5704 10.6148 41.4371 9.28889 40.6593 8.35556C39.9926 7.56296 38.963 7.37778 37.9926 7.26667C36.7556 7.12593 35.5111 7.04444 34.2667 6.99259C31.7482 6.8963 29.2297 6.95556 26.7037 7.00741C25.4074 7.03704 24.1186 7.06667 22.8223 7.16296C21.2371 7.28889 19.6074 7.51852 18.8667 9.08889C18.2074 10.4963 18.2889 12.2815 18.2741 13.7926C18.2741 15.1481 18.2593 16.5037 18.3186 17.8667C18.3926 19.6222 18.4963 21.9185 20.4148 22.6889C21.4371 23.1037 22.6741 23.1926 23.7704 23.2593C24.926 23.3333 26.0963 23.3259 27.2593 23.3407C29.6963 23.3778 32.1334 23.2889 34.5704 23.2444C36.2667 23.2148 38 23.1926 39.6223 22.6444C41.0223 22.1704 41.3852 20.6741 41.5704 19.3778C41.7556 18.0889 41.7111 16.7778 41.7037 15.4741C41.7037 14.5111 41.726 13.5481 41.6963 12.5926",
    fill: "#1E1F22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.6966 15.1333C31.6521 13.9481 29.6521 12.7852 27.6299 11.6074V18.6593C29.6595 17.4815 31.6595 16.3185 33.6966 15.1333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.2959 35.9259H24.0737",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.2959 40.3259H47.6811",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.2959 44.7259H36.17",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.2959 49.1259H30.6589",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.2959 53.5259H43.7996",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M0.370117 30H59.6294",
    stroke: "#1E1F22",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8876_391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContetns);
export default __webpack_public_path__ + "static/media/contetns.8cf0162728ff76e161253671afdc7720.svg";
export { ForwardRef as ReactComponent };